{
  "tab": "Time",
  "perHour": "per hour",
  "settings": {
    "time": {
      "title": "Time",
      "body": "What people may log on projects, and when it locks.",
      "invalid": "Check the time rules: a value is out of range.",
      "range": "Enter a number from {{min}} to {{max}}.",
      "quarter": "Use quarter hours, such as 7.5 or 7.75.",
      "unit": {
        "days": "days",
        "hours": "hours"
      },
      "futureDays": {
        "label": "Days ahead",
        "hint": "Time can be logged this many days ahead, for planned leave or travel. 0 allows today at the latest."
      },
      "lockAfterDays": {
        "label": "Lock after",
        "hint": "Time older than this many days can't be added, changed or submitted. Approvers can still approve or return it."
      },
      "hoursPerDay": {
        "label": "Hours in a working day",
        "hint": "What a member allocated full time is expected to log each working day; a 50% allocation expects half."
      },
      "weekStart": {
        "label": "Week starts on",
        "hint": "The first day of the week in My time and in approvals.",
        "SATURDAY": "Saturday",
        "SUNDAY": "Sunday",
        "MONDAY": "Monday"
      },
      "requireTask": {
        "label": "Every entry names a task",
        "hint": "Time is logged against one of the project's tasks, not only the project or a plan node."
      }
    }
  },
  "time": {
    "off": "Time is turned off for this project. A project manager can turn it on in the project's functions.",
    "title": "Time on this project",
    "intro": "Hours people logged here, by person and week.",
    "period": "{{from}} to {{to}}, by person and week.",
    "none": "None",
    "columns": {
      "week": "Week",
      "draft": "Draft",
      "submitted": "Awaiting approval",
      "approved": "Approved",
      "billable": "Billable",
      "cost": "Cost",
      "bill": "Billable value"
    },
    "state": {
      "DRAFT": "Draft",
      "SUBMITTED": "Awaiting approval",
      "APPROVED": "Approved"
    },
    "empty": "No time logged in this period.",
    "emptyBody": "Members log their hours in My time. Hours show here as drafts, then awaiting approval, then approved.",
    "tableLabel": "Time on {{code}} by person and week",
    "weekOf": "Week of {{date}}",
    "total": "Total",
    "figures": {
      "label": "Time totals for the period",
      "approvedSub": "Hours in the project's cost",
      "submittedSub": "Hours awaiting approval",
      "billableSub": "To bill: approved or waiting",
      "labour": "Labour cost to date",
      "labourSub": "All approved time, every period"
    },
    "footnote": "Hours count in the project's cost once approved, at the person's hourly cost on the day worked. Billable hours bill at the member's own bill rate, else their rate role's.",
    "approve": "Review {{hours}} awaiting approval",
    "approvals": "Time approvals",
    "entries": {
      "toggle": "Entries of {{person}}, {{week}}",
      "label": "Time of {{person}} in the week of {{week}}",
      "hint": "Open a person's week to see its entries; approved time that isn't billed or posted yet can be returned to them.",
      "empty": "No entries on this project in that week.",
      "columns": {
        "date": "Date",
        "work": "Project › plan › task",
        "status": "Status",
        "hours": "Hours"
      },
      "selectAll": "Select all of {{person}}'s returnable entries",
      "select": "Select {{hours}} on {{day}}",
      "billed": "On a customer invoice: void the invoice to return it.",
      "posted": "In a labour posting: void the posting to return it.",
      "waiting": "Awaiting approval: decide it in Time approvals.",
      "own": "Your own time: someone else returns it.",
      "notApproved": "Not approved: nothing to return.",
      "returnBody": "{{hours}} go back to the person with your reason. They correct the time and submit it again; until it's approved again, it leaves the project's cost."
    },
    "logTime": "Log time",
    "openMyTime": "Open My time",
    "inactive": "inactive"
  },
  "roles": {
    "none": "No rate role",
    "new": "New rate role",
    "views": "Rate role views",
    "active": "Active",
    "archived": "Archived",
    "ratesHidden": "Bill rates are prices: you see them with permission to see project money.",
    "emptyActive": "No rate roles yet.",
    "emptyActiveBody": "Add the roles people bill time at, such as Site engineer or Consultant, each with its bill rate per hour.",
    "emptyArchived": "No archived rate roles.",
    "listLabel": "Rate roles",
    "archivedStamp": "Archived",
    "members_one": "{{n}} active member",
    "members_other": "{{n}} active members",
    "noBillRate": "No bill rate: members need their own",
    "edit": "Edit {{name}}",
    "archive": "Archive {{name}}",
    "restore": "Restore {{name}}",
    "archiveTitle": "Archive {{name}}?",
    "archiveBody": "It can't be chosen for members any more. Members who have it keep it, and their time still bills at its rate.",
    "archiveConfirm": "Archive",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "It can be chosen for members again.",
    "restoreConfirm": "Restore",
    "toast": {
      "saved": "Rate role {{code}} saved",
      "archived": "Rate role {{code}} archived",
      "restored": "Rate role {{code}} restored"
    },
    "editTitle": "Edit rate role {{code}}",
    "newTitle": "New rate role",
    "editorDescription": "A role people bill time at on time-and-materials projects. A member's own bill rate, set on the project's team, comes before the role's.",
    "save": "Save rate role",
    "fields": {
      "code": "Code",
      "codeHint": "Short and unique: letters, digits, dot, dash or underscore (SITE-ENG).",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "billRate": "Bill rate per hour (<rial/>, before VAT)",
      "billRateHint": "What an hour of this role bills the customer. Leave it empty if each member has their own."
    }
  },
  "team": {
    "rateRole": "Rate role",
    "billRate": "Bill rate",
    "allocation": "Allocation",
    "fromRole": "from the role",
    "noRate": "No bill rate: set a rate role or own rate",
    "allocationRange": "Enter a whole percentage from 1 to 100, or leave it empty.",
    "timeLegend": "Time and rates",
    "rateRoleHint": "Their billable time bills at this role's rate unless they have their own.",
    "ownBillRate": "Own bill rate per hour (<rial/>)",
    "ownBillRateHint": "Leave it empty to bill at their rate role's rate.",
    "ownBillRateHintRole": "Leave it empty to bill at the role's {{rate}} an hour.",
    "allocationHint": "Their planned share of a working week on this project. Leave it empty if they aren't expected to log set hours here.",
    "noRateNeeded": "None needed: this project doesn't bill time"
  },
  "people": {
    "title": "Hourly costs",
    "subtitle": "What an hour of each person costs the company: it costs their approved time on projects.",
    "ruleTitle": "How a new rate applies",
    "rule": "A new rate applies to time approved from now on, at the rate for the day worked. Time already approved keeps its rate; to re-cost it, return it and approve it again.",
    "views": "Views",
    "all": "Everyone",
    "missing": "Missing a rate",
    "search": "Search people…",
    "clearSearch": "Clear search",
    "columns": {
      "person": "Person",
      "current": "Hourly cost now",
      "next": "Next rate",
      "projects": "Open projects"
    },
    "since": "since {{date}}",
    "from": "from {{date}}",
    "noRate": "No rate",
    "set": "Set a rate from…",
    "actionsFor": "Actions for {{name}}",
    "noMatch": "Nobody matches your search.",
    "noneMissing": "Everyone has a rate.",
    "empty": "Nobody to cost yet. People show here once they are members of an open project.",
    "drawerTitle": "{{name}}: hourly cost",
    "drawerDescription": "Their rates by date, and a new rate from a date.",
    "setTitle": "Set a rate from…",
    "fields": {
      "costRate": "Cost per hour (<rial/>)",
      "costRateHint": "What an hour of their work costs the company: pay and benefits over working hours.",
      "effectiveFrom": "From",
      "note": "Note"
    },
    "applies": "From {{date}}. A new rate applies to time approved from now on; time already approved keeps its rate.",
    "backdated": "From {{date}}. A new rate applies only to time approved from now on; time already approved keeps its rate. To re-cost it, return it and approve it again.",
    "replaces": "Replaces the rate of {{rate}} from {{date}}. It applies to time approved from now on; time already approved keeps its rate. To re-cost it, return it and approve it again.",
    "save": "Save rate",
    "toast": {
      "saved": "{{name}}: {{rate}} an hour from {{date}}"
    },
    "history": "Rates",
    "noHistory": "No rate yet: their time costs 0 when approved. A new rate applies to time approved from now on; to re-cost time already approved, return it and approve it again.",
    "inForce": "In force",
    "upcoming": "Upcoming",
    "setBy": "Set by {{name}}, {{date}}",
    "missingWarning_one": "{{n}} person has no hourly cost: their approved time costs 0",
    "missingWarning_other": "{{n}} people have no hourly cost: their approved time costs 0",
    "showMissing": "Show them"
  },
  "labour": {
    "action": "Post labour cost…",
    "title": "Post labour cost",
    "description": "Approved time to the books, as a labour posting cost entry.",
    "explain": "Debits each project's labour cost and credits the account you choose; time already posted is skipped.",
    "defaultDescription": "Labour cost of approved time to {{date}}",
    "books": "Each line posts to its labour category's account. The projects already counted this cost when the time was approved, so their figures don't change.",
    "fields": {
      "through": "Time worked up to",
      "throughHint": "Approved time worked on or before this date and not posted yet.",
      "project": "Project",
      "projectHint": "Leave it empty for every project you can see; closed projects and those with Cost entries or Time turned off are skipped.",
      "allProjects": "All projects",
      "clearProject": "All projects",
      "entryDate": "Entry date",
      "entryDateHint": "The date of the journal entry.",
      "creditAccount": "Credit account",
      "creditAccountHint": "The account the total is credited to: a liability such as salaries payable or a labour clearing account, or an expense account.",
      "creditAccountPlaceholder": "Choose the account to credit",
      "description": "Description"
    },
    "errors": {
      "account": "Choose the account to credit."
    },
    "preview": "Preview",
    "refresh": "Preview again",
    "post": "Post labour cost",
    "stale": "The details changed since the preview. Preview again before posting.",
    "nothing": "No approved time is waiting to be posted up to this date.",
    "previewTitle_one": "{{count}} approved entry to post",
    "previewTitle_other": "{{count}} approved entries to post",
    "missingTitle_one": "{{count}} entry has no hourly cost",
    "missingTitle_other": "{{count}} entries have no hourly cost",
    "missingBody": "Their people had no rate on the day worked, so they post at 0. To cost them, set a rate from that day, then return the time and approve it again.",
    "setRates": "Set hourly costs",
    "previewCaption": "Lines the posting will debit and credit",
    "creditLine": "Credit",
    "balanced": "Debits equal credits",
    "usualChoice": "{{type}} · usual choice",
    "columns": {
      "project": "Project",
      "node": "Plan node",
      "category": "Category",
      "hours": "Hours",
      "amount": "Amount",
      "debit": "Debit",
      "credit": "Credit"
    },
    "entries_one": "{{count}} entry",
    "entries_other": "{{count}} entries",
    "total": "Total",
    "toast": {
      "posted": "Labour cost posted as {{number}}"
    }
  }
}
